// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulk Import Page Styles */
.bulk-import-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background-color: #f8f9fa;
  min-height: 100vh;
  padding: 0;
}

/* Page Header */
.page-header {
  margin-top: 30px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 4px 0;
}

.page-subtitle {
  font-size: 14px;
  color: #6c757d;
  margin: 0 0 12px 0;
}

.breadcrumb {
  font-size: 12px;
  color: #6c757d;
  margin: 0;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #9ca3af;
}

.breadcrumb-current {
  color: #374151;
}

/* CSV Upload Section */
.csv-upload-section {
  background-color: white;
  margin: 0;
  padding: 32px;
  border-bottom: 1px solid #e9ecef;
}

.csv-template-header {
  margin-bottom: 32px;
}

.csv-template-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
}

.csv-template-description {
  font-size: 14px;
  color: #6c757d;
  margin: 0;
}

/* Upload Area */
.upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  background-color: #fefefe;
  padding: 80px 32px;
  text-align: center;
  margin-bottom: 32px;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  position: relative;
}

.upload-area:hover {
  border-color: #9ca3af;
  background-color: #f9fafb;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-title {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.upload-description {
  font-size: 14px;
  color: #6c757d;
  margin: 0;
}

.file-input {
  display: none;
}

.choose-file-btn {
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.choose-file-btn:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.selected-file {
  font-size: 12px;
  color: #059669;
  margin: 8px 0 0 0;
  font-weight: 500;
}

/* Upload Actions */
.upload-actions {
  display: flex;
  gap: 16px;
  justify-content: flex-start;
}

.download-template-btn {
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  color: #374151;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
}

.download-template-btn:hover {
  background-color: #e5e7eb;
  border-color: #9ca3af;
}

.process-upload-btn {
  background-color: #2563eb;
  border: 1px solid #2563eb;
  color: white;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 14px;
  font-weight: 500;
}

.process-upload-btn:hover {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

/* Currency Rules Section */
.currency-rules-section {
  background-color: white;
  padding: 32px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-actions .btn {
  font-size: 13px;
  padding: 8px 16px;
  border-radius: 6px;
}

/* Table Styles */
.table-container {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.currency-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.currency-table thead {
  background-color: #f8f9fa;
}

.currency-table th {
  padding: 16px 20px;
  font-weight: 500;
  font-size: 13px;
  color: #6c757d;
  border: none;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.currency-table td {
  padding: 20px;
  font-size: 14px;
  color: #6c757d;
  border: none;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f4;
}

.currency-table tr.last-row td {
  border-bottom: none;
}

.revenue-line-cell {
  font-weight: 500;
  color: #2c3e50 !important;
}

.cost-amount-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.external-cost-value {
  font-size: 12px;
  color: #dc3545;
  font-weight: 500;
}

.external-label {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
}

.version-badge {
  background-color: #f8f9fa;
  color: #495057;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #dee2e6;
  display: inline-block;
}

.status-badge {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  display: inline-block;
}

.status-active {
  background-color: #007bff;
}

.status-draft {
  background-color: #ffc107;
}

.status-expired {
  background-color: #dc3545;
}

.actions-container {
  display: flex;
  gap: 8px;
}

.action-button {
  padding: 8px;
  background-color: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.action-button:hover {
  background-color: #f8f9fa;
}
`, "",{"version":3,"sources":["webpack://./src/styles/BulkImport.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE;uCACqC;EACrC,yBAAyB;EACzB,iBAAiB;EACjB,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Bulk Import Page Styles */\n.bulk-import-container {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  background-color: #f8f9fa;\n  min-height: 100vh;\n  padding: 0;\n}\n\n/* Page Header */\n.page-header {\n  margin-top: 30px;\n}\n\n.page-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0 0 4px 0;\n}\n\n.page-subtitle {\n  font-size: 14px;\n  color: #6c757d;\n  margin: 0 0 12px 0;\n}\n\n.breadcrumb {\n  font-size: 12px;\n  color: #6c757d;\n  margin: 0;\n}\n\n.breadcrumb-separator {\n  margin: 0 8px;\n  color: #9ca3af;\n}\n\n.breadcrumb-current {\n  color: #374151;\n}\n\n/* CSV Upload Section */\n.csv-upload-section {\n  background-color: white;\n  margin: 0;\n  padding: 32px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.csv-template-header {\n  margin-bottom: 32px;\n}\n\n.csv-template-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0 0 8px 0;\n}\n\n.csv-template-description {\n  font-size: 14px;\n  color: #6c757d;\n  margin: 0;\n}\n\n/* Upload Area */\n.upload-area {\n  border: 2px dashed #d1d5db;\n  border-radius: 12px;\n  background-color: #fefefe;\n  padding: 80px 32px;\n  text-align: center;\n  margin-bottom: 32px;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n  position: relative;\n}\n\n.upload-area:hover {\n  border-color: #9ca3af;\n  background-color: #f9fafb;\n}\n\n.upload-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.upload-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n}\n\n.upload-description {\n  font-size: 14px;\n  color: #6c757d;\n  margin: 0;\n}\n\n.file-input {\n  display: none;\n}\n\n.choose-file-btn {\n  background-color: white;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.choose-file-btn:hover {\n  background-color: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.selected-file {\n  font-size: 12px;\n  color: #059669;\n  margin: 8px 0 0 0;\n  font-weight: 500;\n}\n\n/* Upload Actions */\n.upload-actions {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-start;\n}\n\n.download-template-btn {\n  background-color: #f3f4f6;\n  border: 1px solid #d1d5db;\n  color: #374151;\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.download-template-btn:hover {\n  background-color: #e5e7eb;\n  border-color: #9ca3af;\n}\n\n.process-upload-btn {\n  background-color: #2563eb;\n  border: 1px solid #2563eb;\n  color: white;\n  border-radius: 8px;\n  padding: 12px 32px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.process-upload-btn:hover {\n  background-color: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n/* Currency Rules Section */\n.currency-rules-section {\n  background-color: white;\n  padding: 32px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.section-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.section-actions .btn {\n  font-size: 13px;\n  padding: 8px 16px;\n  border-radius: 6px;\n}\n\n/* Table Styles */\n.table-container {\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n}\n\n.currency-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.currency-table thead {\n  background-color: #f8f9fa;\n}\n\n.currency-table th {\n  padding: 16px 20px;\n  font-weight: 500;\n  font-size: 13px;\n  color: #6c757d;\n  border: none;\n  text-align: left;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.currency-table td {\n  padding: 20px;\n  font-size: 14px;\n  color: #6c757d;\n  border: none;\n  vertical-align: middle;\n  border-bottom: 1px solid #f1f3f4;\n}\n\n.currency-table tr.last-row td {\n  border-bottom: none;\n}\n\n.revenue-line-cell {\n  font-weight: 500;\n  color: #2c3e50 !important;\n}\n\n.cost-amount-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.external-cost-value {\n  font-size: 12px;\n  color: #dc3545;\n  font-weight: 500;\n}\n\n.external-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6c757d;\n}\n\n.version-badge {\n  background-color: #f8f9fa;\n  color: #495057;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid #dee2e6;\n  display: inline-block;\n}\n\n.status-badge {\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  color: white;\n  display: inline-block;\n}\n\n.status-active {\n  background-color: #007bff;\n}\n\n.status-draft {\n  background-color: #ffc107;\n}\n\n.status-expired {\n  background-color: #dc3545;\n}\n\n.actions-container {\n  display: flex;\n  gap: 8px;\n}\n\n.action-button {\n  padding: 8px;\n  background-color: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n}\n\n.action-button:hover {\n  background-color: #f8f9fa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
